import React, {Component} from "react";
import "./UserProfileInfo.css";
import "../../../Common/Common.css";
import {FormattedMessage} from "react-intl";
import {Link, Route} from "react-router-dom";
import UserEditProfileInfo from "../UserEditProfileInfo/UserEditProfileInfo";
import KitCutLogo from "../../../../assets/img/kitcut_logo.png";
// import user.profile from '../../../../assets/img/user.profile.png'
import user_Profile from "../../../../assets/img/user.profile.png"
import Model from '../../../Common/MessageBox/MessageBox'
import Modal from "react-bootstrap/es/Modal";
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../../configuration";
import Logout from "../../../../Logout";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";

class UserProfileInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            deleteShow: false,
            status: "active",
            showChangePassword: false,
            userName: "",
            user: {},
            userInfo: {},
            userContact: ''

        };
        this.deactivateAccount = this.deactivateAccount.bind(this);
        this.conformDeleteAccount = this.conformDeleteAccount.bind(this);
        this.handleCloseChangePassword = this.handleCloseChangePassword.bind(this);
        this.getUserDetailsForPassword = this.getUserDetailsForPassword.bind(this);
        this.handleShowChangePassword = this.handleShowChangePassword.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.proceedToChangePassword = this.proceedToChangePassword.bind(this);
    }

    proceedToChangePassword = () => {
        this.changePassword();
    };

    handleCloseChangePassword = () => {
        this.setState({
            showChangePassword: false
        })
    };

    handleShowChangePassword = () => {

        this.setState({
            showChangePassword: true
        })
    };

    changePassword = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.post(RESOURCE_BASE_URL + 'api/users/' + this.props.userInfo.id + '/change_password'
            , {
                username: this.state.user.username,
                oldPassword: "test",
                newPassword: "test",
            }, axiosConfig)
            .then((res) => {
                this.setState({
                    showChangePassword: false,
                }, () => {
                    sessionStorage.setItem("a", 'logout');
                    document.cookie = "isLog=logout";
                    InitialQuotationState.isLogged = false;
                    localStorage.clear();

                    localStorage.setItem("pc", "pc");
                    // this.props.keycloak.logout({redirectUri: BASE_URL});

                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getUserDetailsForPassword = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, axiosConfig)
            .then((res) => {
                this.setState({
                    userName: res.data.name,
                    user: res.data,
                    userContact: res.data.phone
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    conformDeleteAccount = (deactivation) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/users/activation/' + this.props.userInfo.id + '/' + deactivation, axiosConfig)
            .then((res) => {

                if (res.data === "active") {
                    this.setState({
                        status: res.data,
                        activateShow: false
                    })
                } else {
                    this.setState({
                        status: res.data,
                        deactivateShow: false,
                    })
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });
    };

    deactivateAccount = () => {


        this.setState({
            activateShow: !this.state.activateShow
        })

    };

    componentDidMount() {
        console.log("user profile userInfo didmount ===> " , this.props.userInfo.userName);
        this.getUserDetailsForPassword();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("user profile userInfo ===> " , this.props.userInfo);
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId, userInfo: this.props.userInfo});
            console.log("user profile userInfo ===> " + this.props.userInfo);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                {this.state.status === "deactive" ? <Logout userData={this.props.userData}/> : ''}

                <div className="row collapse-profile-info">
                    <div className="col-md-1">
                        <div className="row">
                            {/*<div className="user-profile-image">*/}
                            <img className="user-profile-image" src={user_Profile} alt="user.profile"/>
                            {/*</div>*/}

                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-9 no-padding">
                                <div className="user-info-row">
                                    <div className="row">
                                        <div className="col-md-3 user-profile-info-label no-padding">
                                            ユーザー名
                                            :
                                        </div>
                                        <div className="col-md-9">
                                            <div className="name-field pull-left">
                                                {this.props.userInfo.username}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-info-row">
                                    <div className="row">
                                        <div className="col-md-3 user-profile-info-label no-padding">
                                            名前 :
                                        </div>
                                        <div className="col-md-9">
                                            {this.props.userInfo.japaneseLastName +" "+ this.props.userInfo.japaneseFirstName }
                                        </div>
                                    </div>
                                </div>
                                <div className="user-info-row">
                                    <div className="row">
                                        <div className="col-md-3 user-profile-info-label no-padding">
                                            <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                              defaultMessage="Email"
                                                              description=""
                                            /> :
                                        </div>
                                        <div className="col-md-9">
                                            {this.props.userInfo.email}
                                        </div>
                                    </div>
                                </div>
                                <div className="user-info-row">
                                    <div className="row">
                                        <div className="col-md-3 user-profile-info-label no-padding">
                                            電話番号 :
                                        </div>
                                        <div className="col-md-9">
                                            {this.state.userContact}
                                        </div>
                                    </div>
                                </div>


                            </div>
                            {this.props.userData != null && localStorage.getItem("userRole") !== "ROLE_IMPERSONATE"?
                            <div className="col-md-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <UserEditProfileInfo userInfo={this.props.userInfo}
                                                             getUserDetails={this.props.getUserDetails}
                                                             userId={this.props.userId}/>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <span className="change-password-link pull-right">
                                                <a href="/changePassword">
                                                    <FormattedMessage id="app.user-profile.user-profile-info.change-password"
                                                                      defaultMessage="Change Password"
                                                                      description=""
                                                    />
                                                </a>

                                        </span></div>
                                </div>
                                {/*//////////////////////////////////////*/}
                                {this.props.userInfo.userRole === "ROLE_USER" ?
                                    <div className="row">
                                        <div className="col-md-12">
                                        <span className="change-password-link pull-right deactivate-color"
                                              onClick={this.deactivateAccount}>
                                            {/*<span onClick={this.deactivateAccount}>*/}
                                            アカウント削除
                                            {/*</span>*/}
                                        </span></div>
                                    </div> : ''}

                            </div> : '' }
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="user-profile-links-div">
                                <div className="user-profile-link">
                                    <Link to="/order/all">
                                        <FormattedMessage id="app.user-profile.user-profile-info.order-history"
                                                          defaultMessage="View Order History"
                                                          description=""
                                        />
                                    </Link>
                                </div>
                                <div className="user-profile-link">
                                    <Link to="/inquiry_list">
                                        <FormattedMessage id="app.user-profile.user-profile-info.inquiries"
                                                          defaultMessage="View Inquiries"
                                                          description=""
                                        />
                                    </Link>
                                </div>
                                <div className="user-profile-link">
                                    <Link to="/complaint_list">
                                        品質報告履歴
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="collapse-profile-info-mobile">
                    <div className="col-md-1">
                        <div className="profile-img-align">
                            <img className="user-profile-image" src={user_Profile} alt="user.profile"/>
                        </div>
                    </div>
                    <div>
                        <div className='space-height'></div>

                        <div className="">
                            <div className="custom-col-4 user-profile-info-label">
                                ユーザー名 :
                            </div>
                            <div className="custom-col-8">
                                &nbsp;{this.props.userInfo.username}
                            </div>
                        </div>
                    </div>
                    <div className='space-height1'></div>
                    <div>
                        <div className="">
                            <div className="custom-col-4 user-profile-info-label">
                                名前 :
                            </div>
                            <div className="custom-col-8">
                                &nbsp;{this.props.userInfo.japaneseLastName +" "+ this.props.userInfo.japaneseFirstName }
                            </div>
                        </div>
                    </div>
                    <div className='space-height'></div>
                    <div>
                        <div className="">
                            <div className="custom-col-4 user-profile-info-label">
                                <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                  defaultMessage="Email"
                                                  description=""
                                /> :
                            </div>
                            <div className="custom-col-8">
                                &nbsp;{this.props.userInfo.email}
                            </div>
                        </div>
                    </div>
                    <div className='space-height'></div>
                    <div>
                        <div className="">
                            <div className="custom-col-4 user-profile-info-label">
                                電話番号 :
                            </div>
                            <div className="custom-col-8">
                                &nbsp;{this.props.userInfo.phone}
                            </div>
                        </div>
                    </div>
                    <div className='space-height'></div>

                </div>


                <Modal dialogClassName="password-modal" show={this.state.showChangePassword}
                       onHide={this.handleCloseChangePassword}>
                    <Modal.Header>
                        <div className="row password-modal-text">
                            <b>パスワードを変更する</b>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row password-modal-text">
                            パスワードを変更するには、システムに再度ログインする必要があります。これを続行するとログアウトされます
                        </div>
                        <div className="form-row-spacer"></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="row pull-right password-modal-text">
                            <button className="btn btn-primary" onClick={this.proceedToChangePassword}>
                                持続する
                            </button>
                            <button className="btn btn-primary" onClick={this.handleCloseChangePassword}>
                                キャンセル
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName="user-aaaaaa-modal" show={this.state.activateShow}
                       onHide={this.deactivateHandleClose}
                >
                    <Modal.Header closeButton
                                  onHide={this.deactivateHandleClose}>
                        <div className="title-1 color-text">
                            {/*<FormattedMessage id="app.admin-all-row.deactivate-user"*/}
                            {/*defaultMessage="Deactivate User"*/}
                            {/*description=""/>*/}
                            アカウント削除
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">

                                    {/*<FormattedMessage id="app.admin-all-row.deactivate-confirm"*/}
                                    {/*defaultMessage="Are you sure you want to deactivate the user ?"*/}
                                    {/*description=""/>*/}
                                    KITCUTのアカウントを削除すると、アカウントのすべての情報が削除され、<br/>
                                    元に戻すことはできません。
                                    <br/>
                                    <br/>

                                    <b><span className='text-color-user-profile'>アカウントを削除しますか？</span></b>
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={() => this.deactivateAccount(true)}
                            >
                                <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                  defaultMessage="No"
                                                  description=""/>
                            </button>
                            <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                    onClick={() => this.conformDeleteAccount(false)}
                            >
                                <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                  defaultMessage="Yes"
                                                  description=""/>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export default UserProfileInfo;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserProfileInfo/UserProfileInfo.js